<!-- Variant with pill -->
<div
  #flipItemContainer
  (click)="onItemClick()"
  (mouseenter)="setHoveredState(true)"
  (mouseleave)="setHoveredState(false)"
  *ngIf="variant === 'score-pill'"
  [class]="this.selected ? 'item-container-selected' : 'item-container'"
>
  <div class="item-header">
    <span class="item-number">
      {{ number }}
    </span>
    <span class="item-edited">
      <app-category-pill
        #editPill
        (click)="onEditClick($event)"
        *ngIf="this.edited === true && !this.assessmentItemDto.ceilingMet"
        [buttonType]="editButtonType"
      >
        Edit
      </app-category-pill>
    </span>
  </div>
  <div class="item-body">
    <span class="item-description">
      {{ description }}
    </span>
    <span class="item-pill">
      <app-category-pill #categoryPill [buttonType]="buttonType">
        {{ score }}
      </app-category-pill>
    </span>
  </div>
</div>

<!-- Variant with score-text -->
<div *ngIf="variant === 'score-text'" class="flip-item-description">
  <div class="item-number">
    {{ number }}
  </div>
  <div class="item-detail">
    <span class="sub-item-detail">{{ description }}</span>
    <span [ngClass]="_scoreClass">{{ score }}</span>
  </div>
</div>
